module.exports = __webpack_public_path__ + "fonts/icomoon-540ef8.eot";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/icomoon.eot?v=1.0.0
// module id = 811
// module chunks = 2